import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { collection, getDocs } from "firebase/firestore";

export async function getTeams(db: any) {
  const teamCol = collection(db, "teams");
  const teamSnapshot = await getDocs(teamCol);
  const teamList = teamSnapshot.docs.map((doc) => doc.data());
  console.log(teamList);
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
